import React from 'react';
import { recruitmentInfo } from '../data/mock';

const RecruitmentSection = () => {
  return (
    <section className="bg-white py-20 md:py-28 border-t border-gray-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-3xl">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">
            {recruitmentInfo.title}
          </h2>
          <div className="w-12 h-0.5 bg-gray-300 mb-8"></div>

          <p className="text-gray-600 leading-relaxed mb-8">
            {recruitmentInfo.description}
          </p>

          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-block text-gray-900 font-medium text-sm border border-gray-300 px-6 py-2.5 rounded hover:bg-gray-900 hover:text-white hover:border-gray-900 transition-all duration-200"
          >
            Nous contacter
          </a>
        </div>
      </div>
    </section>
  );
};

export default RecruitmentSection;
